<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="1" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container2 v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container2>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container2 from '@/components/Container2.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      Container:{
        video:{
          title:'國人十大癌症 乳癌',
          videosrc:'R04.mp4',

          list:[
            {

              title:'病友分享',
              body:"為一患者罹癌的心路歷程，從被診斷出乳腺癌，到治療計畫規劃、放射治療、後續的追蹤以及實際治療結果的描述。"

            }

          ]
        },
        text:{
          title:'國人十大癌症 － 乳癌',
          videobtnname:'病友分享',
          videoImg:'R04v.png',
          list:[
            {

              title:'乳癌是什麼？',
              body:"是由乳房乳腺管細胞或是線泡細胞經由不正常分裂、繁殖所形成之惡性腫瘤。除了侵犯局部器官（乳房），更可能轉移到遠處器官如骨骼、肺、肝、腦等，造成身體健康之損害。根據國民健康署2016年癌症登記報告顯示，發生率位居第三位。"

            },
            {

              title:'如何治療乳癌？',
              body:"乳癌的治療是很複雜的，醫師會根據各項檢查以及期別而有不同的治療。常見治療方式為手術切除、放射線治療、化學治療、賀爾蒙療法。"

            },
            {

              title:'乳癌放射治療的原因和時機？',
              body:"乳癌的放射治療通常是在您接受外科手術後數週才進行的。放射治療過程中通常會有皮膚局部紅腫、脫皮、小水泡等副作用，此現象在治療結束後會漸漸改善。治療期間應充分休息，亦可安排適當活動，並均衡飲食避免刺激性食物。"

            },
          ]
        }
      },

    }
  },
  components: {
    Back,Container2,Bigmenu
  },
  methods:{
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
